import { makeStyles } from '@material-ui/core/styles';
import { Biomarker } from 'api/generated';
import { FC } from 'react';
import { DeleteButton, SaveButton, Toolbar, ToolbarProps } from 'react-admin';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const BiomarkerToolbar: FC<ToolbarProps> = (props) => {
  const biomarker = props.record as Biomarker;
  const { name } = biomarker;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton label="Save" disabled={props.pristine} />
      <DeleteButton
        confirmTitle="Biomarker remove"
        confirmContent={`Are you sure you want to delete item "${name}"?`}
        label="Remove"
        mutationMode="optimistic"
      />
    </Toolbar>
  );
};
